// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__1eK4u","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2gSOX"};